<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :key="toolbarKey" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"
        :search="filters"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @selection-change="handleSelectionChange" ref="table"
        class="custom-tbl" height="100%" style="width: 100%">
        <el-table-column type="selection" width="50"> </el-table-column>

        <el-table-column label="来源" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.IsAgent ? 'warning' : 'success'" size="small">
              {{ scope.row.IsAgent ? '代请假' : '请假' }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="申请人/被请假人" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.ApplicantName || '-' }} → {{ scope.row.TargetName || scope.row.ApplicantName || '-' }}</div>
            <div class="sub-cell-text">{{ scope.row.DepartmentName || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="LeaveTypeName" label="请假类型" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <div>{{ scope.row.LeaveTypeName || '-' }}</div>
            <div v-if="scope.row.SickLeaveTypes" class="sub-cell-text">{{ scope.row.SickLeaveTypes }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="StartDate" label="请假时间" width="195">
          <template slot-scope="scope">
            <span class="nowrap-cell">{{ formatLeaveStartEnd(scope.row, 'StartDate') }}</span>
            <span class="sub-cell-text nowrap-cell">至 {{ formatLeaveStartEnd(scope.row, 'EndDate') }} · {{ scope.row.LeaveDuration }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="Reason" label="原因" min-width="160" show-overflow-tooltip>
        </el-table-column>

        <el-table-column prop="MediaFile" label="图片" width="100" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.MediaFile" :max="2" />
          </template>
        </el-table-column>

        <el-table-column prop="Status" label="状态/门禁" width="120" align="center">
          <template slot-scope="scope">
            <div class="status-stack">
              <el-tag size="small" :type="getStatusType(scope.row.Status)">{{ getStatusText(scope.row.Status) }}</el-tag>
              <el-tooltip :content="scope.row.TbSyncStatusMessage || '暂无说明'" placement="top">
                <el-tag
                  v-if="scope.row.TbSyncStatus && scope.row.TbSyncStatus !== 'NotApplicable'"
                  size="mini"
                  :type="getTbSyncStatusType(scope.row.TbSyncStatus)"
                  class="tb-sync-clickable"
                  @click="handleViewTbSync(scope.row)">
                  门禁 {{ getTbSyncStatusText(scope.row.TbSyncStatus) }}
                </el-tag>
                <span v-else class="tb-sync-empty">门禁 —</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="CreateTime" label="申请时间" width="190">
          <template slot-scope="scope">
            <span class="nowrap-cell">{{ formatDateTime(scope.row.CreateTime) }}</span>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="110" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleViewApprovalSteps(scope.row)">
              查看流程
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"
          :page-size="pageSize" :total="total" style="float: right"></el-pagination>
      </el-col>

    </section>

    <!-- 审批流程对话框。最后修改：2026-10-19 -->
    <el-dialog title="审批流程" :visible.sync="approvalStepsDialogVisible" width="640px" custom-class="approval-flow-dialog">
      <!-- 代请假模式：使用 Tab 切换 -->
      <el-tabs v-if="currentIsAgent" v-model="activeTabName" type="card">
        <el-tab-pane label="请假明细" name="details">
          <div class="detail-section">
            <el-table :data="agentLeaveDetails" size="mini" border style="width: 100%; margin-top: 10px;" max-height="500px">
              <el-table-column prop="LeaveDate" label="请假日期" width="">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.LeaveDate) }}
                </template>
              </el-table-column>
              <el-table-column label="时间段" min-width="">
                <template slot-scope="scope">
                  {{ scope.row.StartTime }} - {{ scope.row.EndTime }}
                </template>
              </el-table-column>
              <el-table-column label="返校" width="" align="center">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.IsReturnSchool ? 'success' : 'info'" size="mini">
                    {{ scope.row.IsReturnSchool ? '是' : '否' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="TbThirdPartId" label="天波ID" width="120" align="center">
                <template slot-scope="scope">
                  {{ scope.row.TbThirdPartId > 0 ? scope.row.TbThirdPartId : '—' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="审批进度" name="steps">
          <!-- 审批进度 / 抄送与通知：统一面板样式。最后修改：2026-10-19 -->
          <div class="flow-panel" style="margin-top: 8px;">
            <div class="flow-panel-head">
              <div class="flow-panel-title">
                <i class="el-icon-s-check"></i>
                <span>审批进度</span>
                <span v-if="approvalCreateTime" class="flow-create-time">创建时间：{{ approvalCreateTime }}</span>
              </div>
              <span v-if="approvalSteps.length" class="flow-count">{{ approvalSteps.length }} 人</span>
            </div>
            <div v-if="approvalSteps.length > 0" class="approval-steps-grid">
              <div
                v-for="step in approvalSteps"
                :key="step.Id"
                class="approval-step-card"
                :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
                <div class="step-card-head">
                  <div class="step-card-main">
                    <span class="step-badge">步骤 {{ step.StepNumber }}</span>
                    <span class="step-name">{{ step.ApproverName || '-' }}</span>
                  </div>
                  <el-tag size="mini" :type="getApprovalStepStatusType(step.Status)" effect="plain">
                    {{ getApprovalStepStatusText(step.Status) }}
                  </el-tag>
                </div>
                <div class="step-card-time">审批时间：{{ formatDateTime(step.ApprovedAt) }}</div>
                <div v-if="step.Comments" class="step-card-comment">审批意见：{{ step.Comments }}</div>
              </div>
            </div>
            <div v-else class="no-data no-data-compact">暂无审批流程记录</div>
          </div>
          <div class="flow-panel">
            <div class="flow-panel-head">
              <div class="flow-panel-title">
                <i class="el-icon-message"></i>
                <span>抄送与通知</span>
                <el-tag v-if="ccFromCurrentConfig" size="mini" type="warning" effect="plain">当前配置 · 仅供参考</el-tag>
                <el-tag v-else size="mini" type="success" effect="plain">提交快照</el-tag>
              </div>
              <span v-if="ccPersonList.length" class="flow-count">{{ ccPersonList.length }} 人</span>
            </div>
            <div class="cc-panel-block">
              <div class="cc-block-label">指定人员</div>
              <div v-if="ccPersonList.length" class="cc-people">
                <span v-for="(name, index) in ccPersonList" :key="index" class="cc-person-chip" :title="name">
                  <i class="el-icon-user"></i>{{ name }}
                </span>
              </div>
              <div v-else class="cc-empty">未指定抄送人员</div>
            </div>
            <div class="cc-flags">
              <div class="cc-flag" :class="ccClassTeacher ? 'is-on' : 'is-off'">
                <span class="cc-flag-dot"></span>
                <div class="cc-flag-text">
                  <div class="cc-flag-name">抄送班主任</div>
                  <div class="cc-flag-val">{{ ccClassTeacher ? '已开启' : '未开启' }}</div>
                </div>
              </div>
              <div class="cc-flag" :class="notifyParent ? 'is-on' : 'is-off'">
                <span class="cc-flag-dot"></span>
                <div class="cc-flag-text">
                  <div class="cc-flag-name">通知家长</div>
                  <div class="cc-flag-val">{{ notifyParent ? '已开启' : '未开启' }}</div>
                </div>
              </div>
            </div>
            <div v-if="ccFromCurrentConfig" class="cc-note">
              无提交快照时，以上按学生当前匹配的流程配置展示，仅供参考
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!-- 普通请假模式：直接显示审批进度 -->
      <div v-else>
        <div class="flow-panel">
          <div class="flow-panel-head">
            <div class="flow-panel-title">
              <i class="el-icon-s-check"></i>
              <span>审批进度</span>
              <span v-if="approvalCreateTime" class="flow-create-time">创建时间：{{ approvalCreateTime }}</span>
            </div>
            <span v-if="approvalSteps.length" class="flow-count">{{ approvalSteps.length }} 人</span>
          </div>
          <div v-if="approvalSteps.length > 0" class="approval-steps-grid">
            <div
              v-for="step in approvalSteps"
              :key="step.Id"
              class="approval-step-card"
              :class="['step-tone-' + (((step.StepNumber || 1) - 1) % 4), 'is-' + (step.Status || 'Pending')]">
              <div class="step-card-head">
                <div class="step-card-main">
                  <span class="step-badge">步骤 {{ step.StepNumber }}</span>
                  <span class="step-name">{{ step.ApproverName || '-' }}</span>
                </div>
                <el-tag size="mini" :type="getApprovalStepStatusType(step.Status)" effect="plain">
                  {{ getApprovalStepStatusText(step.Status) }}
                </el-tag>
              </div>
              <div class="step-card-time">审批时间：{{ formatDateTime(step.ApprovedAt) }}</div>
              <div v-if="step.Comments" class="step-card-comment">审批意见：{{ step.Comments }}</div>
            </div>
          </div>
          <div v-else class="no-data no-data-compact">暂无审批流程记录</div>
        </div>
        <div class="flow-panel">
          <div class="flow-panel-head">
            <div class="flow-panel-title">
              <i class="el-icon-message"></i>
              <span>抄送与通知</span>
              <el-tag v-if="ccFromCurrentConfig" size="mini" type="warning" effect="plain">当前配置 · 仅供参考</el-tag>
              <el-tag v-else size="mini" type="success" effect="plain">提交快照</el-tag>
            </div>
            <span v-if="ccPersonList.length" class="flow-count">{{ ccPersonList.length }} 人</span>
          </div>
          <div class="cc-panel-block">
            <div class="cc-block-label">指定人员</div>
            <div v-if="ccPersonList.length" class="cc-people">
              <span v-for="(name, index) in ccPersonList" :key="index" class="cc-person-chip" :title="name">
                <i class="el-icon-user"></i>{{ name }}
              </span>
            </div>
            <div v-else class="cc-empty">未指定抄送人员</div>
          </div>
          <div class="cc-flags">
            <div class="cc-flag" :class="ccClassTeacher ? 'is-on' : 'is-off'">
              <span class="cc-flag-dot"></span>
              <div class="cc-flag-text">
                <div class="cc-flag-name">抄送班主任</div>
                <div class="cc-flag-val">{{ ccClassTeacher ? '已开启' : '未开启' }}</div>
              </div>
            </div>
            <div class="cc-flag" :class="notifyParent ? 'is-on' : 'is-off'">
              <span class="cc-flag-dot"></span>
              <div class="cc-flag-text">
                <div class="cc-flag-name">通知家长</div>
                <div class="cc-flag-val">{{ notifyParent ? '已开启' : '未开启' }}</div>
              </div>
            </div>
          </div>
          <div v-if="ccFromCurrentConfig" class="cc-note">
            无提交快照时，以上按学生当前匹配的流程配置展示，仅供参考
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalStepsDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 统一报表门禁下发详情。最后更新：2026-10-22 -->
    <el-dialog title="门禁下发详情" :visible.sync="tbSyncDialogVisible" width="820px">
      <el-table :data="tbSyncItems" border stripe size="mini">
        <el-table-column prop="name" label="下发类型" width="110" />
        <el-table-column prop="time" label="时间段" min-width="240" />
        <el-table-column label="状态" width="110" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="getTbSyncStatusType(scope.row.status)">
              {{ getTbSyncStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="tbId" label="天波ID" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.tbId > 0 ? scope.row.tbId : '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="message" label="说明" min-width="180" show-overflow-tooltip />
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tbSyncDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

    <leave-status-check-dialog
      :visible.sync="statusCheckVisible"
      source="all"
      :department-id="DepartmentId"
      @fixed="handleQuery"
    />

  </section>
</template>

<script>
import { getUnifiedLeaveRequestByDepartment, getLeaveRequestByDepartment, getAgentLeaveRequestByDepartment, getLeaveTypeList, exportUnifiedLeaveRequestByDepartment, deleteUnifiedLeaveRequests } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "../../promissionRouter";
import { fetchStudentLiveTypesByDeptId, applyLiveTypeFilterOptions } from '../../utils/studentLiveType'
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import LeaveStatusCheckDialog from './components/LeaveStatusCheckDialog.vue'

export default {
  components: { Toolbar, DepartmentPane, LeaveStatusCheckDialog },
  data() {
    return {
      filters: {},
      toolbarKey: Date.now(),
      BaseApiUrl: BaseApiUrl,
      searchList: [
        { label: '申请人', key: 'name' },
        { label: '代请人', key: 'agentName' },
        {
          label: '请假类型',
          key: 'leaveType',
          type: 'select',
          options: []
        },
        {
          label: '学生类型',
          key: 'liveTypeId',
          type: 'select',
          options: [
            { label: '全部', value: '' }
          ]
        },
        { label: '申请开始时间', key: 'applyStartDate', type: 'datetime', init: false },
        { label: '申请结束时间', key: 'applyEndDate', type: 'datetime', init: false },
        { label: '请假开始时间', key: 'leaveDate', type: 'datetime', init: false },
        { label: '请假结束时间', key: 'leaveEndDate', type: 'datetime', init: false },
        {
          label: '状态',
          key: 'status',
          type: 'select',
          init: true,
          options: [
            { label: '全部', value: '' },
            { label: '待审批', value: 'Pending' },
            { label: '审批中', value: 'InProgress' },
            { label: '已批准', value: 'Approved' },
            { label: '已拒绝', value: 'Rejected' },
            { label: '已取消', value: 'Cancel' },
            { label: '已结束', value: 'Ended' }
          ]
        },
      ],
      users: [],
      total: 0,
      buttonList: [],
      page: 1,
      pageSize: 10,
      listLoading: false,
      multipleSelection: [],
      DepartmentId: 0,
      approvalStepsDialogVisible: false,
      approvalSteps: [],
      ccPersonList: [],
      ccClassTeacher: false,
      notifyParent: true,
      ccFromCurrentConfig: false,
      currentIsAgent: false,
      agentLeaveDetails: [],
      activeTabName: 'details',
      tbSyncDialogVisible: false,
      tbSyncItems: [],
      statusCheckVisible: false,
    };
  },
  computed: {
    // 取第一个审批节点的创建时间。最后修改：2026-10-19
    approvalCreateTime() {
      if (!this.approvalSteps || !this.approvalSteps.length) return '';
      const first = this.approvalSteps.reduce((min, step) => {
        if (!min) return step;
        return (step.StepNumber || 0) < (min.StepNumber || 0) ? step : min;
      }, null);
      if (!first || !first.CreateTime) return '';
      return this.formatDateTime(first.CreateTime);
    }
  },
  methods: {
    async loadLiveTypeFilter(departmentId) {
      const types = await fetchStudentLiveTypesByDeptId(departmentId);
      applyLiveTypeFilterOptions(this.searchList, types);
    },
    treeNodeClick(data) {
      this.DepartmentId = data.Id;
      this.loadLiveTypeFilter(this.DepartmentId);
      // 获取请假类型
      getLeaveTypeList({ departmentId: this.DepartmentId }).then((res) => {
        if (res.data && res.data.response) {
          const types = res.data.response.map((t) => ({
            label: t.Name,
            value: t.Id
          }));
          const leaveTypeSearch = this.searchList.find(
            (item) => item.key === 'leaveType'
          );
          if (leaveTypeSearch) {
            leaveTypeSearch.options = [{ label: '全部', value: '' }, ...types];
          }
          this.filters = {}; // 重置过滤器
          this.toolbarKey = Date.now();
          this.handleQuery(); // 获取数据
        } else {
          this.handleQuery();
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getUsers();
    },

    handleQuery() {
      this.page = 1;
      this.getUsers();
    },
    getUsers() {
      let para = {
        page: this.page,
        intPageSize: this.pageSize,
        departmentId: this.DepartmentId,
        ...this.filters
      };
      this.listLoading = true;
      getUnifiedLeaveRequestByDepartment(para).then(async (res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'MediaFile');
        this.users = rows;
        this.listLoading = false;
      });
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatDateTime(dateTime) {
      if (!dateTime || dateTime.startsWith('0001')) return '-';
      const date = new Date(dateTime);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatDate(date) {
      if (!date || date.startsWith('0001')) return '-';
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    /** 普通请假显示时分秒，代请假仅显示年月日（与请假报表/代请假报表一致） */
    formatLeaveStartEnd(row, field) {
      const val = row && row[field];
      if (row && row.IsAgent) {
        return this.formatDate(val);
      }
      const value = this.formatDateTime(val);
      return value && value.length >= 16 ? value.substring(0, 16) : value;
    },
    getStatusType(status) {
      const typeMap = {
        'Pending': 'warning',
        'InProgress': 'info',
        'Approved': 'success',
        'Ended': 'success',
        'Rejected': 'danger',
        'Cancel': 'info'
      };
      return typeMap[status] || 'default';
    },
    getStatusText(status) {
      const statusMap = {
        'Pending': '待审批',
        'InProgress': '审批中',
        'Approved': '已批准',
        'Rejected': '已拒绝',
        'Cancel': '已取消',
        'Ended': '已结束'
      };
      return statusMap[status] || status;
    },
    // 获取门禁同步状态样式。最后更新：2026-10-22
    getTbSyncStatusType(status) {
      return {
        Pending: 'warning',
        Processing: 'info',
        Success: 'success',
        PartialFailed: 'warning',
        Failed: 'danger',
        Unknown: 'info',
        NotApplicable: 'info'
      }[status] || 'info';
    },
    // 获取门禁同步状态文本。最后更新：2026-10-22
    getTbSyncStatusText(status) {
      return {
        Pending: '待同步',
        Processing: '同步中',
        Success: '已下发',
        PartialFailed: '部分失败',
        Failed: '下发失败',
        Unknown: '—',
        NotApplicable: '—'
      }[status] || '—';
    },
    // 查看统一报表中的门禁状态详情。最后更新：2026-10-22
    async handleViewTbSync(row) {
      if (!row || !row.TbSyncStatus || row.TbSyncStatus === 'NotApplicable') return;
      try {
        const apiFunc = row.IsAgent ? getAgentLeaveRequestByDepartment : getLeaveRequestByDepartment;
        const res = await apiFunc({ id: row.Id });
        const detail = res.data && res.data.response && res.data.response.data
          ? res.data.response.data[0]
          : null;
        if (!detail) {
          this.$message.warning('未找到门禁下发详情');
          return;
        }

        if (row.IsAgent) {
          this.tbSyncItems = (detail.Details || []).map(item => ({
            name: '请假',
            time: `${this.formatDate(item.LeaveDate)} ${item.StartTime} - ${item.EndTime}`,
            status: item.TbThirdPartId > 0 || item.IssueStatus === 1 ? 'Success' : 'Unknown',
            tbId: item.TbThirdPartId,
            message: item.TbThirdPartId > 0 ? '已下发' : '历史记录无法判断门禁同步状态'
          }));
        } else {
          this.tbSyncItems = [{
            name: '请假',
            time: `${this.formatLeaveStartEnd(detail, 'StartDate')} 至 ${this.formatLeaveStartEnd(detail, 'EndDate')}`,
            status: detail.TbSyncStatus,
            tbId: detail.TbThirdPartId,
            message: detail.TbSyncStatusMessage || ''
          }];
          if (detail.ReturnSchoolPeriod) {
            const returnPeriod = detail.ReturnSchoolPeriod;
            this.tbSyncItems.push({
              name: '返校',
              time: `${this.formatDate(returnPeriod.ReturnDate)} ${returnPeriod.ReturnStartTime} - ${returnPeriod.ReturnEndTime}`,
              status: returnPeriod.TbThirdPartId > 0 ? 'Success' : 'Unknown',
              tbId: returnPeriod.TbThirdPartId,
              message: returnPeriod.TbThirdPartId > 0 ? '已下发' : '历史记录无法判断门禁同步状态'
            });
          }
        }
        this.tbSyncDialogVisible = true;
      } catch (error) {
        this.$message.error('获取门禁下发详情失败');
      }
    },
    getApprovalStepStatusType(status) {
      const typeMap = {
        'Pending': 'warning',
        'Approved': 'success',
        'Rejected': 'danger',
        'Cancel': 'info'
      };
      return typeMap[status] || 'default';
    },
    getApprovalStepStatusText(status) {
      const statusMap = {
        'Pending': '待审批',
        'Approved': '已批准',
        'Rejected': '已拒绝',
        'Cancel': '已取消'
      };
      return statusMap[status] || '未知状态';
    },
    handleViewApprovalSteps(row) {
      this.currentIsAgent = row.IsAgent;
      this.agentLeaveDetails = [];
      this.activeTabName = 'details'; // 默认切换到明细 Tab
      this.ccPersonList = [];
      this.ccClassTeacher = false;
      this.notifyParent = true;
      this.ccFromCurrentConfig = false;
      const apiFunc = row.IsAgent ? getAgentLeaveRequestByDepartment : getLeaveRequestByDepartment;
      apiFunc({ id: row.Id }).then(res => {
        const detail = res.data.response.data[0];
        if (detail) {
          this.approvalSteps = detail.LeaveApprovalSteps || [];
          this.ccPersonList = this.parseCcPersonNames(detail.CcPersonNames);
          this.ccClassTeacher = !!detail.CcClassTeacher;
          this.notifyParent = detail.NotifyParent !== false;
          this.ccFromCurrentConfig = !!detail.CcFromCurrentConfig;
          if (row.IsAgent) {
            this.agentLeaveDetails = detail.Details || [];
          }
          this.approvalStepsDialogVisible = true;
        } else {
          this.$message.warning('未找到详情信息');
        }
      });
    },
    // 抄送姓名拆成列表。最后修改：2026-10-19
    parseCcPersonNames(val) {
      if (!val) return [];
      return String(val).split('|').map(s => s.trim()).filter(s => s);
    },

    // 导出 Excel
    exportExcel() {
      const para = {
        departmentId: this.DepartmentId,
        name: this.filters.name || '',
        agentName: this.filters.agentName || '',
        applyStartDate: this.filters.applyStartDate || '',
        applyEndDate: this.filters.applyEndDate || '',
        leaveDate: this.filters.leaveDate || '',
        leaveEndDate: this.filters.leaveEndDate || '',
        leaveType: this.filters.leaveType || '',
        liveTypeId: this.filters.liveTypeId || '',
        status: this.filters.status || ''
      };

      this.$message.info('正在准备导出，请稍候...');
      exportUnifiedLeaveRequestByDepartment(para).then((res) => {
        if (res.status === 200 && res.data) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const downloadElement = document.createElement('a');
          const href = window.URL.createObjectURL(blob);
          const fileName = `统一请假报表_${new Date().getTime()}.xlsx`;

          downloadElement.href = href;
          downloadElement.download = fileName;
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      }).catch((e) => {
        this.$message.error('导出出错');
      });
    },

    // 批量删除
    handleDelUsers() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的记录');
        return;
      }

      this.$confirm('确定要删除选中的记录吗？（普通请假和代请假将分别执行对应的删除逻辑）', '提示', {
        type: 'warning'
      }).then(() => {
        const dtos = this.multipleSelection.map(item => ({
          Id: item.Id,
          IsAgent: item.IsAgent
        }));

        this.listLoading = true;
        deleteUnifiedLeaveRequests(dtos).then(res => {
          this.listLoading = false;
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '删除成功');
            this.handleQuery();
          } else {
            this.$message.error(res.data ? res.data.msg : '删除失败');
          }
        }).catch(() => {
          this.listLoading = false;
          this.$message.error('删除请求出错');
        });
      });
    },

    /** 打开统一请假状态异常检查弹窗 */
    handleLeaveStatusCheck() {
      this.statusCheckVisible = true;
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    if (!this.buttonList.some(item => item.Func === 'handleLeaveStatusCheck')) {
      this.buttonList.push({
        name: '检查',
        Func: 'handleLeaveStatusCheck',
        id: 993,
        IsHide: false,
        btnType: 'warning'
      });
    }
  }
};
</script>

<style scoped>
/* 门禁状态可查看下发详情。最后更新：2026-10-22 */
.tb-sync-clickable {
  cursor: pointer;
}

.status-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.tb-sync-empty {
  color: #a8abb2;
  font-size: 12px;
  line-height: 18px;
}

.nowrap-cell {
  white-space: nowrap;
}

.sub-cell-text {
  display: block;
  margin-top: 3px;
  color: #909399;
  font-size: 12px;
  line-height: 16px;
}

/* 审批流程弹窗：统一面板。最后修改：2026-10-19 */
.flow-panel {
  margin-bottom: 12px;
  padding: 14px 16px 12px;
  border: 1px solid #dbe4f0;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.flow-panel:last-of-type {
  margin-bottom: 0;
}

.flow-panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #d7e2ef;
}

.flow-panel-title {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1e3a5f;
}

.flow-panel-title i {
  width: 26px;
  height: 26px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(37, 99, 235, 0.12);
  color: var(--btn-primary, #2563eb);
  font-size: 14px;
}

.flow-create-time {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}

.flow-count {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
}

.approval-steps-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  max-height: 320px;
  overflow-y: auto;
}

.approval-step-card {
  flex: 0 0 calc(50% - 6px);
  box-sizing: border-box;
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.approval-step-card.step-tone-0 {
  border-color: #bfdbfe;
  background: #f8fbff;
}

.approval-step-card.step-tone-0 .step-badge {
  background: #2563eb;
}

.approval-step-card.step-tone-1 {
  border-color: #ddd6fe;
  background: #faf8ff;
}

.approval-step-card.step-tone-1 .step-badge {
  background: #7c3aed;
}

.approval-step-card.step-tone-2 {
  border-color: #99f6e4;
  background: #f0fdfa;
}

.approval-step-card.step-tone-2 .step-badge {
  background: #0d9488;
}

.approval-step-card.step-tone-3 {
  border-color: #fed7aa;
  background: #fff7ed;
}

.approval-step-card.step-tone-3 .step-badge {
  background: #ea580c;
}

.step-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.step-card-main {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.step-badge {
  flex-shrink: 0;
  padding: 2px 8px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
}

.step-name {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.step-card-time {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.step-card-comment {
  margin-top: 6px;
  padding-left: 8px;
  border-left: 2px solid #93c5fd;
  max-height: 72px;
  overflow-y: auto;
  font-size: 12px;
  color: #1e3a5f;
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.step-card-comment::-webkit-scrollbar {
  width: 4px;
}

.step-card-comment::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.cc-panel-block {
  margin-bottom: 12px;
}

.cc-block-label {
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
}

.cc-people {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.cc-people::-webkit-scrollbar {
  width: 6px;
}

.cc-people::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.cc-person-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 160px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f8fafc;
  border: 1px solid #c7d7f0;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cc-person-chip i {
  flex-shrink: 0;
  font-size: 12px;
  color: #3b82f6;
}

.cc-empty {
  font-size: 13px;
  color: #94a3b8;
}

.cc-flags {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.cc-flag {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: #fff;
  transition: border-color 0.2s, background 0.2s;
}

.cc-flag.is-on {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.cc-flag.is-off {
  border-color: #e2e8f0;
  background: #f8fafc;
}

.cc-flag-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cc-flag.is-on .cc-flag-dot {
  background: #22c55e;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.15);
}

.cc-flag.is-off .cc-flag-dot {
  background: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.15);
}

.cc-flag-name {
  font-size: 12px;
  color: #64748b;
  line-height: 1.2;
}

.cc-flag-val {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.2;
}

.cc-flag.is-off .cc-flag-val {
  color: #64748b;
  font-weight: 500;
}

.cc-note {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #d7e2ef;
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.5;
}

.no-data {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.no-data-compact {
  padding: 18px 0 12px;
}
</style>
